import { render, staticRenderFns } from "./CoLegalLinks.vue?vue&type=template&id=29b9f55c&scoped=true&"
import script from "./CoLegalLinks.vue?vue&type=script&lang=ts&"
export * from "./CoLegalLinks.vue?vue&type=script&lang=ts&"
import style0 from "./CoLegalLinks.vue?vue&type=style&index=0&id=29b9f55c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b9f55c",
  null
  
)

export default component.exports